import { Email, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { getTitleTranslationKey, guardString } from "@msuite/utils/strings";
import type { ContactMember } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ContactMember>();

export const columnsWithoutActions = [
	columnHelper.accessor("title", {
		id: "title",
		header: localized("profile.title"),
		cell: (info) => localized(getTitleTranslationKey(guardString(info.getValue()))),
	}),
	columnHelper.accessor("firstName", {
		id: "firstName",
		header: localized("profile.first_name"),
		cell: (info) => info.getValue(),
	}),
	columnHelper.accessor("lastName", {
		id: "lastName",
		header: localized("profile.last_name"),
		cell: (info) => info.getValue(),
	}),
	columnHelper.accessor("email", {
		id: "email",
		header: localized("personnel.fields.email"),
		cell: (info) => <Email>{guardString(info.getValue())}</Email>,
	}),
	columnHelper.accessor("phone", {
		id: "phone",
		header: localized("personnel.fields.phone"),
		cell: (info) => <Phone>{guardString(info.getValue())}</Phone>,
	}),
	columnHelper.accessor("_type.name", {
		id: "type",
		header: localized("general.type"),
		cell: (info) =>
			info.row.original?._type?.name ? (
				<Tag
					color={info.row.original?._type?.color}
					variant="plain"
				>
					{info.getValue()}
				</Tag>
			) : (
				guardString(null)
			),
	}),
	columnHelper.accessor((row) => row._authorizations.map((auth) => auth._type.name).join(", "), {
		id: "authorizations",
		header: localized("contacts.member_authorizations"),
		cell: (info) => info.getValue(),
	}),
];

export const columnActions = [createRowActions(RowActions)];

export const columnContact = [
	columnHelper.accessor((row) => row._contact?.name || "", {
		id: "contactName",
		header: localized("contacts.contact"),
		cell: (cell) => guardString(cell.getValue()),
	}),
];

export const columns = [...columnsWithoutActions, ...columnActions];
